export default {
  vgn: {
    name: 'Vegan',
    emoji: '🌱',
  },
  vgt: {
    name: 'Vegetarian',
    emoji: '🥬',
  },
  gf: {
    name: 'Fără gluten',
  },
  df: {
    name: 'Fără lactate',
  },
  hal: {
    name: 'Halal',
  },
  'h&s': {
    name: 'Picant',
    emoji: '🌶',
  },
};
